<template>
    <!-- 在根元素上添加v-loading指令 -->
    <div class="main" v-loading.fullscreen.lock="isLoading" element-loading-text="登录中..."
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: true, // 控制loading显示状态
            qyIndexUrl: '',//企业首页路由
            ptIndexUrl: '',//平台首页路由
            ygIndexUrl: '',//员工首页路由
        };
    },
    async created() {
        await this.getjumpUrl()

        this.init()
    },

    mounted() {
        // 模拟登录过程，实际项目中替换为真实登录API

    },
    methods: {
        //获取跳转路由
        getjumpUrl() {
            return this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        "dictionary_code": "XTSZ-SYLY"
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        let jumpUrlArr = res.data.data.dictionary_detail
                        jumpUrlArr.forEach(item => {
                            if (item.dictionary_value == '企业首页') {
                                this.qyIndexUrl = item.dictionary_key
                            }
                            if (item.dictionary_value == '平台首页') {
                                this.ptIndexUrl = item.dictionary_key
                            }
                            if (item.dictionary_value == '普通首页') {
                                this.ygIndexUrl = item.dictionary_key
                            }
                        })
                    } else {
                        this.$message({
                            type: "error", message: res.data.msg, onClose: () => {
                                localStorage.clear()
                                this.$router.push({
                                    path: "/login"
                                })
                            }
                        });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                })
        },
        init() {
            let obj = this.$route.query;
            if (Reflect.has(obj, 'user') && Reflect.has(obj, 'pass') && Reflect.has(obj, 'isPhone')) {
                if (obj.isPhone == 'true') {
                    this.phoneLogin(obj.user, obj.pass)
                } else {
                    this.pcLogin(obj.user, decodeURIComponent(obj.pass))

                }
            } else {
                this.$router.push({
                    path: "/login"
                })

            }
            console.log(obj);

        },
        pcLogin(uN, uP) {

            this.$tools
                .asyncPost(this, this.$baseUrl.Login, {
                    data: {
                        uname: uN,
                        pass: uP,
                        eplogin: true
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        if (res.data.data.perms != undefined || res.data.data.acctype == 3) {
                            localStorage.clear()
                            localStorage.setItem('token', res.data.data.token)
                            localStorage.setItem('id', res.data.data.id)
                            localStorage.setItem("department", res.data.data.department)
                            localStorage.setItem("perms", res.data.data.perms)
                            localStorage.setItem("acctype", res.data.data.acctype)
                            localStorage.setItem("user_type", res.data.data.user_type ?? res.data.data.acctype)
                            localStorage.setItem("useritem", JSON.stringify(res.data.data))
                            if (res.data.data.enterprise != null) {
                                localStorage.setItem('enterprise_id', res.data.data.enterprise.enterprise_id)
                            }
                            if (res.data.data.acctype == 3) {
                                this.$router.push({ path: this.ptIndexUrl, });
                            } else if (res.data.data.acctype == 2) {
                                this.$router.push({ path: this.qyIndexUrl, });
                            } else {
                                this.$router.push({ path: this.ygIndexUrl, });
                            }
                            this.$message({ type: "success", message: "登录成功", duration: 500 });
                        } else {
                            this.$alert("没有权限,等待企业管理员审核通过", "提示", {
                                confirmButtonText: '确定',
                                callback: () => {
                                    localStorage.clear()
                                    this.$router.push({
                                        path: "/login"
                                    })
                                }
                            })
                        }
                    } else {
                        this.$message({
                            type: "error", message: res.data.msg, onClose: () => {
                                localStorage.clear()
                                this.$router.push({
                                    path: "/login"
                                })
                            }
                        });
                    }
                })
                .catch((err) => {
                    // this.$message({ type: "error", message: err });
                });
        },
        phoneLogin(uN, uP) {

            this.$tools
                .asyncPost(this, this.$baseUrl.Loginstep2, {
                    data: {
                        phone: uN,
                        code: uP,
                        eplogin: true
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        localStorage.clear()
                        if (res.data.data.need_register == true) {
                            localStorage.setItem('token', res.data.data.token)
                            this.$router.push({ path: "/registerperfect", query: { n: uN } });
                        } else {
                            if (res.data.data.perms != undefined || res.data.data.acctype == 3) {

                                localStorage.setItem('token', res.data.data.token)
                                localStorage.setItem('id', res.data.data.id)
                                localStorage.setItem("department", res.data.data.department)
                                localStorage.setItem("perms", res.data.data.perms)
                                localStorage.setItem("acctype", res.data.data.acctype)
                                localStorage.setItem("user_type", res.data.data.user_type ?? res.data.data.acctype)
                                localStorage.setItem("useritem", JSON.stringify(res.data.data))
                                if (res.data.data.enterprise != null) {
                                    localStorage.setItem('enterprise_id', res.data.data.enterprise.enterprise_id)
                                }
                                if (res.data.data.acctype == 3) {
                                    this.$router.push({ path: this.ptIndexUrl, });
                                } else if (res.data.data.acctype == 2) {
                                    this.$router.push({ path: this.qyIndexUrl, });
                                } else {
                                    this.$router.push({ path: this.ygIndexUrl, });
                                }
                                this.$message({ type: "success", message: "登录成功", duration: 500 });
                            } else {
                                this.$alert("没有权限,等待企业管理员审核通过", "提示", {
                                    confirmButtonText: '确定',
                                    callback: () => {
                                        localStorage.clear()
                                    }
                                })
                            }
                        }
                    } else {
                        this.$message({
                            type: "error", message: res.data.msg, onClose: () => {
                                localStorage.clear()
                                this.$router.push({
                                    path: "/login"
                                })
                            }
                        });

                    }
                })
                .catch((err) => {

                    // this.$message({ type: "error", message: err });
                });
        }

    }
}
</script>

<style scoped>
.main {
    height: 100vh;
}

/* 移除原自定义loading样式，使用Element UI内置loading */</style>